import { waitForElementToExist } from './waitForElement';
/* eslint-disable */
export const accountPage = () => {
	const pageStyle = ({ page }) => {
		const main = page.closest('#primary')
		if (!main) return
		if (!page.querySelector('.c7-account__header')) return

		page.classList = 'c7-account grid grid-cols-1 grid grid-rows-[minmax(0,auto),minmax(0,auto),minmax(0,1fr)] grid-cols-[minmax(0,1fr)] gap-y-6';
		const pageHeader = page.querySelector('.c7-account__header')
		pageHeader && (pageHeader.classList = 'c7-account__header col-start-1 row-start-1 row-end-3 col-span-1 bg-[#343633] relative z-10 pb-28');
		const pageNav = page.querySelector('.c7-account__menu');
		pageNav && (pageNav.classList = 'c7-account__menu col-start-1 row-start-2 col-span-1 bg-transparent mb-0 relative z-10 mb-4');

		if (pageHeader) {
			const bgImage = document.createElement('img')
			/* image background */
			bgImage.src = template.texture_default;
			bgImage.classList = 'absolute inset-0 object-cover object-top w-full h-full mix-blend-multiply opacity-50 z-[1]'
			pageHeader.appendChild(bgImage)

			const wrapper = pageHeader.querySelector('.c7-wrapper')
			if (!wrapper) return
			wrapper.classList = 'c7-wrapper w-full z-10 relative text-left flex flex-col items-start';

			const pHeadline = wrapper.querySelector('p')
			pHeadline && (pHeadline.classList = 'hidden');
			const welcomeMessage = pHeadline.nextElementSibling
			const logOut = welcomeMessage.querySelector('a')
			logOut && (logOut.classList = 'relative lg:absolute -order-1 mb-4 lg:right-4 top-0 uppercase font-bold flex gap-2');
			logOut && (logOut.style = '--c7-body-text-color: var(--yellow-light); color: var(--yellow-light)');
			logOut && logOut.remove();
			wrapper.insertAdjacentElement('afterbegin', logOut);
			welcomeMessage && (welcomeMessage.classList = 'text-white text-lg font-semibold mb-6');
			const c7Marker = wrapper.querySelector('.c7-marker')
			c7Marker && (c7Marker.classList = '-order-1 py-1 px-3 uppercase text-sm font-semibold text-white bg-[#484A47] rounded-full monospace-font mb-3');
			const headline = document.createElement('h3')
			headline.classList = 'text-4xl xl:text-6xl font-semibold headlines-font headline-title uppercase mb-6 text-primary text-left after:self-start gap-4';
			headline.innerHTML = pHeadline.innerHTML.replace('Hello ', 'Hello, ');
			wrapper.insertAdjacentElement('afterbegin', headline);
		}

		const sectionContainer = main.querySelector('.mx-auto')
		if (!sectionContainer) return
		sectionContainer.classList = 'w-full bg-[#f0efe7]';

		const sectionDetail = page.querySelector('.c7-account-order-detail__content')
		sectionDetail && (sectionDetail.classList = 'order-receipt w-11/12 mx-auto max-w-8xl flex flex-wrap gap-5 lg:gap-0 justify-center');
	}

	waitForElementToExist({ selector: '#c7-content .c7-account .c7-account__header' }).then(() => {
		const c7Content = document.querySelector('#c7-content');
		c7Content && (c7Content.style = 'padding-top: 0; padding-inline: 0;');
		const page = document.querySelector('#c7-content .c7-account');
		pageStyle({ page });

		const observerAccount = new MutationObserver(() => {
			const page = document.querySelector('#c7-content .c7-account');
			pageStyle({ page });
		});

		observerAccount.observe(document.querySelector('#c7-content'), { childList: true });
	});

}